var _rect, _path, _path2, _rect2, _g, _rect3, _rect4, _mask, _rect5, _g2, _rect6, _path3, _g3, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgIllustration = function SvgIllustration(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 285,
    height: 362,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "illustration_svg__b",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 285,
    height: 362
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 284.744,
    height: 361.962,
    rx: 4.107,
    fill: "url(#illustration_svg__a)"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#illustration_svg__b)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.35 180.625-164.812-1.536",
    stroke: "url(#illustration_svg__c)",
    strokeWidth: 0.329,
    strokeDasharray: "2.64 2.64"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m-35.272-112.354 346.269 346.269",
    stroke: "url(#illustration_svg__d)",
    strokeWidth: 0.329,
    strokeDasharray: "2.64 2.64"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 265.285,
    y: 116.051,
    width: 173.998,
    height: 173.998,
    rx: 0.33,
    transform: "rotate(135 265.285 116.051)",
    stroke: "url(#illustration_svg__e)",
    strokeWidth: 0.66,
    strokeLinejoin: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#illustration_svg__f)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 265.285,
    y: 255.791,
    width: 173.998,
    height: 173.998,
    rx: 0.33,
    transform: "rotate(135 265.285 255.791)",
    stroke: "url(#illustration_svg__g)",
    strokeWidth: 0.66,
    strokeLinejoin: "round"
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.4,
    x: 265.285,
    y: 255.791,
    width: 173.998,
    height: 173.998,
    rx: 0.33,
    transform: "rotate(135 265.285 255.791)",
    stroke: "url(#illustration_svg__h)",
    strokeWidth: 0.66,
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#illustration_svg__i)"
  }, _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 265.752,
    y: 185.27,
    width: 174.658,
    height: 174.658,
    rx: 0.66,
    transform: "rotate(135 265.752 185.27)",
    fill: "#7010BE"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "illustration_svg__k",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 19,
    y: 62,
    width: 247,
    height: 247
  }, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "illustration_svg__j",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 265.752,
    y: 185.27,
    width: 174.658,
    height: 174.658,
    rx: 0.66,
    transform: "rotate(135 265.752 185.27)"
  }))), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 265.752,
    y: 185.27,
    width: 174.658,
    height: 174.658,
    rx: 0.66,
    transform: "rotate(135 265.752 185.27)",
    fill: "#D9D9D9",
    stroke: "#A112FF",
    strokeWidth: 2,
    strokeLinejoin: "round",
    mask: "url(#illustration_svg__j)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#illustration_svg__k)",
    stroke: "#A112FF"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.42013 .87064 -.21557 -.86448 -28.03 39.648)",
    d: "M0-.5h371.144"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.42013 .87064 -.21557 -.86448 -21.662 38.549)",
    d: "M0-.5h371.144"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.42013 .87064 -.21557 -.86448 -15.3 37.453)",
    d: "M0-.5h371.144"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.42013 .87064 -.21557 -.86448 -8.938 36.361)",
    d: "M0-.5h371.144"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.42013 .87064 -.21557 -.86448 -2.57 35.268)",
    d: "M0-.5h371.144"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.42013 .87064 -.21557 -.86448 3.793 34.172)",
    d: "M0-.5h371.144"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.42013 .87064 -.21557 -.86448 10.158 33.072)",
    d: "M0-.5h371.144"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.42013 .87064 -.21557 -.86448 16.521 31.979)",
    d: "M0-.5h371.144"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.42013 .87064 -.21557 -.86448 22.885 30.885)",
    d: "M0-.5h371.144"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.42013 .87064 -.21557 -.86448 29.25 29.791)",
    d: "M0-.5h371.144"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.42013 .87064 -.21557 -.86448 35.613 28.693)",
    d: "M0-.5h371.144"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.42013 .87064 -.21557 -.86448 41.977 27.596)",
    d: "M0-.5h371.144"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.42013 .87064 -.21557 -.86448 48.34 26.504)",
    d: "M0-.5h371.144"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.42013 .87064 -.21557 -.86448 54.707 25.41)",
    d: "M0-.5h371.144"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.42013 .87064 -.21557 -.86448 61.068 24.313)",
    d: "M0-.5h371.144"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.42013 .87064 -.21557 -.86448 67.434 23.217)",
    d: "M0-.5h371.144"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.42013 .87064 -.21557 -.86448 73.799 22.121)",
    d: "M0-.5h371.144"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.42013 .87064 -.21557 -.86448 80.162 21.027)",
    d: "M0-.5h371.144"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.42013 .87064 -.21557 -.86448 86.523 19.932)",
    d: "M0-.5h371.144"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.42013 .87064 -.21557 -.86448 92.89 18.836)",
    d: "M0-.5h371.144"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.42013 .87064 -.21557 -.86448 99.256 17.742)",
    d: "M0-.5h371.144"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.42013 .87064 -.21557 -.86448 105.619 16.648)",
    d: "M0-.5h371.144"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.42013 .87064 -.21557 -.86448 111.982 15.549)",
    d: "M0-.5h371.144"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.42013 .87064 -.21557 -.86448 118.346 14.455)",
    d: "M0-.5h371.144"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.42013 .87064 -.21557 -.86448 124.709 13.36)",
    d: "M0-.5h371.144"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.42013 .87064 -.21557 -.86448 131.078 12.266)",
    d: "M0-.5h371.144"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.42013 .87064 -.21557 -.86448 137.439 11.166)",
    d: "M0-.5h371.144"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.42013 .87064 -.21557 -.86448 143.803 10.074)",
    d: "M0-.5h371.144"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.42013 .87064 -.21557 -.86448 150.168 8.979)",
    d: "M0-.5h371.144"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.42013 .87064 -.21557 -.86448 156.531 7.883)",
    d: "M0-.5h371.144"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.42013 .87064 -.21557 -.86448 162.893 6.79)",
    d: "M0-.5h371.144"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.42013 .87064 -.21557 -.86448 169.256 5.691)",
    d: "M0-.5h371.144"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.42013 .87064 -.21557 -.86448 175.621 4.598)",
    d: "M0-.5h371.144"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.42013 .87064 -.21557 -.86448 181.988 3.498)",
    d: "M0-.5h371.144"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.42013 .87064 -.21557 -.86448 188.352 2.408)",
    d: "M0-.5h371.144"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.42013 .87064 -.21557 -.86448 194.715 1.309)",
    d: "M0-.5h371.144"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.42013 .87064 -.21557 -.86448 201.078 .215)",
    d: "M0-.5h371.144"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.42013 .87064 -.21557 -.86448 207.441 -.88)",
    d: "M0-.5h371.144"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.42013 .87064 -.21557 -.86448 213.809 -1.979)",
    d: "M0-.5h371.144"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.42013 .87064 -.21557 -.86448 220.172 -3.072)",
    d: "M0-.5h371.144"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.42013 .87064 -.21557 -.86448 226.535 -4.168)",
    d: "M0-.5h371.144"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.42013 .87064 -.21557 -.86448 232.9 -5.262)",
    d: "M0-.5h371.144"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.42013 .87064 -.21557 -.86448 -34.389 40.742)",
    d: "M0-.5h371.144"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.42013 .87064 -.21557 -.86448 -40.756 41.838)",
    d: "M0-.5h371.144"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.42013 .87064 -.21557 -.86448 -47.123 42.935)",
    d: "M0-.5h371.144"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.42013 .87064 -.21557 -.86448 -53.484 44.03)",
    d: "M0-.5h371.144"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.42013 .87064 -.21557 -.86448 -59.848 45.125)",
    d: "M0-.5h371.144"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.42013 .87064 -.21557 -.86448 -66.209 46.219)",
    d: "M0-.5h371.144"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.42013 .87064 -.21557 -.86448 -72.576 47.318)",
    d: "M0-.5h371.144"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.42013 .87064 -.21557 -.86448 -78.941 48.41)",
    d: "M0-.5h371.144"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.42013 .87064 -.21557 -.86448 -85.303 49.506)",
    d: "M0-.5h371.144"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.42013 .87064 -.21557 -.86448 -91.664 50.6)",
    d: "M0-.5h371.144"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.42013 .87064 -.21557 -.86448 -98.027 51.7)",
    d: "M0-.5h371.144"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.42013 .87064 -.21557 -.86448 -104.395 52.795)",
    d: "M0-.5h371.144"
  }))), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 265.285,
    y: 185.27,
    width: 173.998,
    height: 173.998,
    rx: 0.33,
    transform: "rotate(135 265.285 185.27)",
    stroke: "#A112FF",
    strokeWidth: 0.66,
    strokeLinejoin: "round"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M328.668 492.939 146.506 310.778",
    stroke: "url(#illustration_svg__l)",
    strokeWidth: 0.329,
    strokeDasharray: "2.64 2.64"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#illustration_svg__m)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 265.285,
    y: 116.049,
    width: 173.998,
    height: 173.998,
    rx: 0.33,
    transform: "rotate(135 265.285 116.049)",
    stroke: "url(#illustration_svg__n)",
    strokeWidth: 0.66,
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "illustration_svg__a",
    x1: 284.744,
    y1: 160.168,
    x2: 0,
    y2: 160.168,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#270741"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#340957"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "illustration_svg__c",
    x1: 16.852,
    y1: 181.123,
    x2: -203.019,
    y2: 92.302,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A112FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5543"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "illustration_svg__d",
    x1: -35.77,
    y1: -111.855,
    x2: 4.705,
    y2: 267.079,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00CBEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A112FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "illustration_svg__e",
    x1: 353.081,
    y1: 116.051,
    x2: 353.081,
    y2: 290.709,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A112FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#129BFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "illustration_svg__g",
    x1: 353.081,
    y1: 255.791,
    x2: 353.081,
    y2: 430.449,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A112FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#129BFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "illustration_svg__h",
    x1: 353.081,
    y1: 255.791,
    x2: 353.081,
    y2: 430.449,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A112FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#129BFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "illustration_svg__l",
    x1: 329.166,
    y1: 492.441,
    x2: 240.345,
    y2: 272.571,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00CBEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A112FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "illustration_svg__n",
    x1: 353.081,
    y1: 116.049,
    x2: 353.081,
    y2: 290.707,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A112FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#129BFF"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "illustration_svg__f",
    x: 16.386,
    y: 129.927,
    width: 251.728,
    height: 251.728,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.318,
    result: "effect1_foregroundBlur_9465_40244"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "illustration_svg__i",
    x: -6.015,
    y: 53.476,
    width: 296.53,
    height: 296.53,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 7.906,
    "in": "SourceAlpha",
    result: "effect1_dropShadow_9465_40244"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 16.471
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 16.471
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_9465_40244"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_9465_40244",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "illustration_svg__m",
    x: -6.015,
    y: -15.745,
    width: 296.53,
    height: 296.53,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 7.906,
    "in": "SourceAlpha",
    result: "effect1_dropShadow_9465_40244"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 16.471
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 16.471
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_9465_40244"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_9465_40244",
    result: "shape"
  })))));
};

export { SvgIllustration as ReactComponent };
export default "data:image/svg+xml;base64,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";